import SvgIcon from '@mui/material/SvgIcon';

export const PlayButton = ({ ...rest }) => {
  return (
    <SvgIcon {...rest} viewBox="0 0 80 80">
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
        <g filter="url(#filter0_b_5436_30179)">
          <path
            d="M40 80C17.9086 80 2.13558e-07 62.0914 4.76995e-07 40C7.40432e-07 17.9086 17.9086 2.13558e-07 40 4.76995e-07C62.0914 7.40432e-07 80 17.9086 80 40C80 62.0914 62.0914 80 40 80Z"
            fill="url(#paint0_linear_5436_30179)"
          />
          <path
            d="M40 79.7297C18.0579 79.7297 0.270254 61.9421 0.270255 40C0.270255 18.0579 18.0579 0.270256 40 0.270257C61.9421 0.270257 79.7297 18.0579 79.7297 40C79.7297 61.9421 61.9421 79.7297 40 79.7297Z"
            stroke="url(#paint1_linear_5436_30179)"
            strokeOpacity="0.6"
            strokeWidth="0.540508"
          />
          <path
            d="M40 79.7297C18.0579 79.7297 0.270254 61.9421 0.270255 40C0.270255 18.0579 18.0579 0.270256 40 0.270257C61.9421 0.270257 79.7297 18.0579 79.7297 40C79.7297 61.9421 61.9421 79.7297 40 79.7297Z"
            stroke="url(#paint2_linear_5436_30179)"
            strokeWidth="0.540508"
          />
        </g>
        <path
          d="M34.3672 33.2226C34.3672 31.7861 35.9682 30.9293 37.1634 31.7261L47.3337 38.5063C48.4016 39.2182 48.4016 40.7874 47.3337 41.4993L37.1634 48.2795C35.9682 49.0763 34.3672 48.2195 34.3672 46.783V33.2226Z"
          fill="url(#paint3_linear_5436_30179)"
          stroke="white"
          strokeWidth="1.79856"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="39.7159" cy="40.2841" r="29.8049" stroke="white" strokeWidth="1.79856" />
        <defs>
          <filter
            id="filter0_b_5436_30179"
            x="-5.09466"
            y="-5.09466"
            width="90.1893"
            height="90.1893"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.54733" />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_5436_30179"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_backgroundBlur_5436_30179"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_5436_30179"
            x1="4.76995e-07"
            y1="40"
            x2="47.5857"
            y2="-24.0733"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#8A8A8A" stopOpacity="0.37" />
            <stop offset="1" stopColor="#2E2E2E" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_5436_30179"
            x1="31.9814"
            y1="-15.3409"
            x2="32.8484"
            y2="11.9783"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D8D8D8" />
            <stop offset="1" stopColor="#EFEFEF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_5436_30179"
            x1="65.6338"
            y1="-4.22536"
            x2="60.2096"
            y2="80.5185"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#BABABA" stopOpacity="0.5" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_5436_30179"
            x1="41.9728"
            y1="29.8619"
            x2="56.3995"
            y2="37.8977"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B6B6B6" stopOpacity="0.37" />
            <stop offset="1" stopColor="#6C6C6C" stopOpacity="0.2" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export const CampaignDashboardMenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00098 17.333V14.6665"
      stroke="#185C65"
      strokeWidth="1.33327"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.001 17.3333V10.667"
      stroke="#185C65"
      strokeWidth="1.33327"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 17.3331V6.66699"
      stroke="#185C65"
      strokeWidth="1.33327"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CampaignPageMenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6667 7.9999C12.6667 8.17671 12.5965 8.34628 12.4714 8.4713C12.3464 8.59633 12.1768 8.66657 12 8.66657C11.4696 8.66657 10.9609 8.87728 10.5858 9.25236C10.2107 9.62743 10 10.1361 10 10.6666C10 10.8434 9.92979 11.013 9.80476 11.138C9.67974 11.263 9.51017 11.3333 9.33335 11.3333C9.15654 11.3333 8.98697 11.263 8.86195 11.138C8.73692 11.013 8.66668 10.8434 8.66668 10.6666C8.66774 9.78284 9.01927 8.93561 9.64417 8.31071C10.2691 7.68582 11.1163 7.33429 12 7.33323C12.1768 7.33323 12.3464 7.40347 12.4714 7.52849C12.5965 7.65352 12.6667 7.82309 12.6667 7.9999ZM18.0001 10.6666C18.0029 11.7844 17.692 12.8806 17.1027 13.8305C16.5134 14.7804 15.6695 15.5459 14.6667 16.0399V16.6666C14.6667 16.8434 14.5965 17.013 14.4715 17.138C14.3464 17.263 14.1769 17.3333 14 17.3333H10C9.82321 17.3333 9.65364 17.263 9.52862 17.138C9.40359 17.013 9.33335 16.8434 9.33335 16.6666V16.0399C8.37544 15.5647 7.56195 14.8421 6.97706 13.9469C6.39218 13.0517 6.05717 12.0164 6.00669 10.9483C5.95621 9.88016 6.19211 8.81794 6.68997 7.87158C7.18783 6.92522 7.92955 6.1291 8.83838 5.56563C9.7472 5.00216 10.7901 4.6918 11.8591 4.66669C12.9282 4.64158 13.9845 4.90263 14.9188 5.4228C15.8531 5.94298 16.6313 6.70339 17.1731 7.62534C17.7148 8.54728 18.0003 9.59725 18.0001 10.6666ZM16.6667 10.6666C16.6671 9.81976 16.4371 8.9888 16.0013 8.26274C15.5654 7.53668 14.9403 6.94289 14.1928 6.545C13.4452 6.14711 12.6035 5.96011 11.7579 6.00406C10.9122 6.048 10.0944 6.32123 9.39215 6.79445C8.6899 7.26768 8.12965 7.92307 7.77143 8.69039C7.41322 9.45772 7.27054 10.308 7.3587 11.1503C7.44685 11.9925 7.76251 12.7948 8.27185 13.4714C8.78119 14.1479 9.465 14.673 10.25 14.9906C10.3731 15.0404 10.4786 15.1258 10.5528 15.2359C10.627 15.346 10.6667 15.4758 10.6667 15.6086V15.9999H13.3334V15.6086C13.3334 15.4758 13.373 15.346 13.4473 15.2359C13.5215 15.1258 13.6269 15.0404 13.75 14.9906C14.6129 14.6443 15.3521 14.0471 15.8721 13.2763C16.392 12.5054 16.6688 11.5964 16.6667 10.6666ZM14 19.3333C14.1769 19.3333 14.3464 19.2631 14.4715 19.138C14.5965 19.013 14.6667 18.8434 14.6667 18.6666C14.6667 18.4898 14.5965 18.3202 14.4715 18.1952C14.3464 18.0702 14.1769 18 14 18H10C9.82321 18 9.65364 18.0702 9.52862 18.1952C9.40359 18.3202 9.33335 18.4898 9.33335 18.6666C9.33335 18.8434 9.40359 19.013 9.52862 19.138C9.65364 19.2631 9.82321 19.3333 10 19.3333H14Z"
      fill="#185C65"
    />
  </svg>
);

export const LogOutMenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5948 12.6854L13.1719 14.2557C13.2362 14.3194 13.2872 14.3953 13.322 14.4788C13.3568 14.5624 13.3748 14.652 13.3748 14.7425C13.3748 14.8331 13.3568 14.9227 13.322 15.0062C13.2872 15.0898 13.2362 15.1656 13.1719 15.2294C13.1082 15.2937 13.0324 15.3447 12.9488 15.3795C12.8652 15.4143 12.7756 15.4322 12.6851 15.4322C12.5946 15.4322 12.5049 15.4143 12.4214 15.3795C12.3378 15.3447 12.262 15.2937 12.1982 15.2294L9.45541 12.4866C9.39298 12.4214 9.34405 12.3445 9.31141 12.2603C9.24283 12.0933 9.24283 11.9061 9.31141 11.7391C9.34405 11.655 9.39298 11.5781 9.45541 11.5129L12.1982 8.77003C12.2622 8.7061 12.3381 8.65538 12.4216 8.62078C12.5051 8.58618 12.5947 8.56837 12.6851 8.56837C12.7755 8.56837 12.865 8.58618 12.9486 8.62078C13.0321 8.65538 13.108 8.7061 13.1719 8.77003C13.2359 8.83397 13.2866 8.90987 13.3212 8.9934C13.3558 9.07694 13.3736 9.16647 13.3736 9.25689C13.3736 9.3473 13.3558 9.43683 13.3212 9.52037C13.2866 9.6039 13.2359 9.6798 13.1719 9.74374L11.5948 11.314H18.1707C18.3526 11.314 18.527 11.3862 18.6556 11.5148C18.7842 11.6434 18.8564 11.8179 18.8564 11.9997C18.8564 12.1816 18.7842 12.356 18.6556 12.4846C18.527 12.6132 18.3526 12.6854 18.1707 12.6854H11.5948ZM11.9994 5.14265C13.2809 5.13693 14.5384 5.49045 15.6292 6.16311C16.72 6.83577 17.6005 7.80066 18.1707 8.94832C18.2526 9.11199 18.266 9.30147 18.2082 9.47508C18.1503 9.64868 18.0258 9.79218 17.8622 9.87402C17.6985 9.95586 17.509 9.96933 17.3354 9.91146C17.1618 9.85359 17.0183 9.72913 16.9365 9.56545C16.503 8.69003 15.8436 7.94624 15.0264 7.41096C14.2092 6.87567 13.2639 6.56831 12.2882 6.52064C11.3125 6.47296 10.3418 6.6867 9.47631 7.13977C8.61085 7.59284 7.88208 8.2688 7.3653 9.0978C6.84852 9.92679 6.56249 10.8788 6.53677 11.8553C6.51104 12.8318 6.74655 13.7975 7.21897 14.6526C7.69138 15.5076 8.38355 16.221 9.22396 16.719C10.0644 17.217 11.0225 17.4816 11.9994 17.4854C13.0219 17.4898 14.0249 17.2058 14.8933 16.6661C15.7617 16.1264 16.4603 15.3527 16.909 14.434C16.9909 14.2703 17.1344 14.1458 17.308 14.088C17.4816 14.0301 17.6711 14.0436 17.8347 14.1254C17.9984 14.2072 18.1229 14.3507 18.1807 14.5243C18.2386 14.698 18.2251 14.8874 18.1433 15.0511C17.5997 16.1452 16.7736 17.0741 15.7506 17.7418C14.7275 18.4096 13.5447 18.7919 12.3243 18.8492C11.104 18.9065 9.8905 18.6368 8.80937 18.0679C7.72825 17.499 6.81875 16.6515 6.17494 15.6133C5.53114 14.575 5.17641 13.3836 5.14746 12.1622C5.11851 10.9409 5.41637 9.73399 6.01025 8.66638C6.60413 7.59876 7.47246 6.70919 8.52541 6.08968C9.57836 5.47017 10.7777 5.14322 11.9994 5.14265Z"
      fill="#185C65"
    />
    <path
      d="M11.5948 12.6883L13.1719 14.2586C13.2362 14.3223 13.2872 14.3982 13.322 14.4817C13.3568 14.5653 13.3748 14.6549 13.3748 14.7455C13.3748 14.836 13.3568 14.9256 13.322 15.0092C13.2872 15.0927 13.2362 15.1686 13.1719 15.2323C13.1082 15.2966 13.0324 15.3476 12.9488 15.3824C12.8652 15.4172 12.7756 15.4351 12.6851 15.4351C12.5946 15.4351 12.5049 15.4172 12.4214 15.3824C12.3378 15.3476 12.262 15.2966 12.1982 15.2323L9.45541 12.4895C9.39298 12.4243 9.34405 12.3474 9.31141 12.2632C9.24283 12.0963 9.24283 11.909 9.31141 11.7421C9.34405 11.6579 9.39298 11.581 9.45541 11.5158L12.1982 8.77295C12.2622 8.70902 12.3381 8.6583 12.4216 8.6237C12.5051 8.5891 12.5947 8.57129 12.6851 8.57129C12.7755 8.57129 12.865 8.5891 12.9486 8.6237C13.0321 8.6583 13.108 8.70902 13.1719 8.77295C13.2359 8.83688 13.2866 8.91278 13.3212 8.99632C13.3558 9.07985 13.3736 9.16938 13.3736 9.2598C13.3736 9.35022 13.3558 9.43975 13.3212 9.52328C13.2866 9.60682 13.2359 9.68272 13.1719 9.74665L11.5948 11.3169H18.1707C18.3526 11.3169 18.527 11.3892 18.6556 11.5178C18.7842 11.6464 18.8564 11.8208 18.8564 12.0026C18.8564 12.1845 18.7842 12.3589 18.6556 12.4875C18.527 12.6161 18.3526 12.6883 18.1707 12.6883H11.5948Z"
      fill="#185C65"
    />
  </svg>
);

export const VentureClubIcon = () => {
  return (
    <SvgIcon sx={{ height: '24px', width: '24px' }} viewBox="0 0 24 24">
      <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_i_5178_33033)">
          <rect
            x="4.28516"
            y="4.28564"
            width="15.4286"
            height="15.4286"
            rx="7.71429"
            fill="url(#paint0_linear_5178_33033)"
          />
        </g>
        <rect
          x="4.28516"
          y="4.28564"
          width="15.4286"
          height="15.4286"
          rx="7.71429"
          stroke="url(#paint1_linear_5178_33033)"
          strokeWidth="0.219328"
          strokeLinejoin="round"
        />
        <g filter="url(#filter1_i_5178_33033)">
          <path
            d="M15.1065 11.2888L12.1894 11.2888L13.5129 7.58404L9.06689 12.8143L11.8634 12.8142L10.8854 17.3904L15.1065 11.2888Z"
            fill="url(#paint2_linear_5178_33033)"
          />
        </g>
        <path
          d="M15.1065 11.2888L12.1894 11.2888L13.5129 7.58404L9.06689 12.8143L11.8634 12.8142L10.8854 17.3904L15.1065 11.2888Z"
          stroke="url(#paint3_linear_5178_33033)"
          strokeWidth="0.219328"
          strokeLinejoin="round"
        />
        <defs>
          <filter
            id="filter0_i_5178_33033"
            x="4.17578"
            y="4.17578"
            width="15.6475"
            height="16.1934"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.545404" />
            <feGaussianBlur stdDeviation="0.272702" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5178_33033" />
          </filter>
          <filter
            id="filter1_i_5178_33033"
            x="8.95703"
            y="7.47461"
            width="6.25879"
            height="10.5708"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.545404" />
            <feGaussianBlur stdDeviation="0.272702" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5178_33033" />
          </filter>
          <linearGradient
            id="paint0_linear_5178_33033"
            x1="17.118"
            y1="-0.6188"
            x2="16.2034"
            y2="25.8474"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FEFFDD" />
            <stop offset="0.989583" stopColor="#E17C05" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_5178_33033"
            x1="17.118"
            y1="-0.6188"
            x2="16.2034"
            y2="25.8474"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FEFFDD" />
            <stop offset="0.989583" stopColor="#E17C05" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_5178_33033"
            x1="15.5484"
            y1="4.72333"
            x2="10.8597"
            y2="21.4578"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#FFFAF3" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_5178_33033"
            x1="15.5484"
            y1="4.72333"
            x2="10.8597"
            y2="21.4578"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FEFFDD" />
            <stop offset="0.989583" stopColor="#E17C05" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export const PortfolioMenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.32533 6.62914C8.50204 7.03913 7.78403 7.63291 7.22676 8.36459C6.66949 9.09628 6.2879 9.94628 6.11145 10.8489C5.935 11.7516 5.96843 12.6827 6.20915 13.5704C6.44987 14.458 6.89144 15.2785 7.49973 15.9683C8.10803 16.6582 8.86678 17.1989 9.71735 17.5488C10.5679 17.8987 11.4875 18.0484 12.4052 17.9863C13.3228 17.9242 14.2139 17.652 15.0095 17.1906C15.8052 16.7293 16.4842 16.0912 16.994 15.3257"
      stroke="#185C65"
      strokeWidth="1.28571"
      strokeLinecap="round"
    />
    <path
      d="M17.9926 12.2978C18.0317 11.5108 17.9154 10.7239 17.6504 9.98184C17.3854 9.23982 16.9768 8.55727 16.448 7.97315C15.9192 7.38903 15.2805 6.91479 14.5684 6.57751C13.8563 6.24022 13.0847 6.0465 12.2978 6.00739"
      stroke="#185C65"
      strokeWidth="1.28571"
      strokeLinecap="round"
    />
    <path
      d="M12 6V11.6667C12 12.0349 12.2985 12.3333 12.6667 12.3333H18"
      stroke="#185C65"
      strokeWidth="1.28571"
      strokeLinecap="round"
    />
  </svg>
);

export const ReferInvestorMenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.51557 11.9995V18.8562H17.4863V11.9995"
      stroke="#01D1B8"
      strokeWidth="1.28571"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.14397 8.57129H18.8574V11.9997H5.14397V8.57129Z"
      stroke="#01D1B8"
      strokeWidth="1.28571"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18.8564V8.57129"
      stroke="#185C65"
      strokeWidth="1.28571"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M11.9991 8.57094H15.0846C15.5393 8.57094 15.9753 8.39034 16.2968 8.06887C16.6182 7.7474 16.7988 7.31139 16.7988 6.85676C16.7988 6.40213 16.6182 5.96612 16.2968 5.64465C15.9753 5.32318 15.5393 5.14258 15.0846 5.14258C12.6848 5.14258 11.9991 8.57094 11.9991 8.57094Z"
      stroke="#185C65"
      strokeWidth="1.28571"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8.57094H8.91447C8.45985 8.57094 8.02384 8.39034 7.70237 8.06887C7.38089 7.7474 7.20029 7.31139 7.20029 6.85676C7.20029 6.40213 7.38089 5.96612 7.70237 5.64465C8.02384 5.32318 8.45985 5.14258 8.91447 5.14258C11.3143 5.14258 12 8.57094 12 8.57094Z"
      stroke="#185C65"
      strokeWidth="1.28571"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingsMenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.2449 8.16194L13.9273 8.72085L13.9273 8.72085L14.2449 8.16194ZM9.59352 8.16194L9.27588 7.60304L9.27588 7.60304L9.59352 8.16194ZM9.53793 8.19353L9.85557 8.75244L9.85557 8.75243L9.53793 8.19353ZM9.53793 16.187L9.85557 15.6281L9.85556 15.6281L9.53793 16.187ZM9.59352 16.2186L9.27588 16.7775L9.27588 16.7775L9.59352 16.2186ZM14.2449 16.2186L14.5625 16.7775L14.5625 16.7775L14.2449 16.2186ZM14.3005 16.187L13.9828 15.6281L13.9828 15.6281L14.3005 16.187ZM14.3005 8.19353L14.6181 7.63463V7.63463L14.3005 8.19353ZM14.6444 8.40956L15.01 7.88081L14.6444 8.40956ZM16.6075 11.776L15.9673 11.8338L16.6075 11.776ZM16.8743 11.1814L16.5135 10.6493L16.8743 11.1814ZM14.6412 15.9732L14.276 15.4441L14.6412 15.9732ZM15.2763 15.9074L15.5489 15.3252L15.2763 15.9074ZM13.4927 16.9308L12.8519 16.8789L13.4927 16.9308ZM13.8753 16.4076L13.6081 15.823L13.8753 16.4076ZM12.9693 18.2932L12.8619 17.6594L12.9693 18.2932ZM13.424 17.7797L12.7832 17.7278L13.424 17.7797ZM10.4185 17.78L9.7777 17.8318L10.4185 17.78ZM10.8733 18.2935L10.7661 18.9274L10.8733 18.2935ZM9.9667 16.4093L9.69995 16.9942L9.9667 16.4093ZM10.3499 16.9327L9.70913 16.9845L10.3499 16.9327ZM8.56375 15.9085L8.29108 15.3263L8.56375 15.9085ZM9.19859 15.9741L9.56358 15.445L9.19859 15.9741ZM6.96476 13.2056L7.32548 13.7378L6.96476 13.2056ZM6.96439 11.1789L6.60367 11.711L6.96439 11.1789ZM7.2311 11.7737L6.59088 11.7156L7.2311 11.7737ZM6.03259 10.0439L5.43048 9.81863L6.03259 10.0439ZM6.2536 10.697L6.61432 10.1649L6.2536 10.697ZM16.7478 8.23342L16.2568 8.64839L16.7478 8.23342ZM16.0825 8.09977L16.3552 8.68193L16.0825 8.09977ZM7.75867 8.0992L8.03133 7.51703L7.75867 8.0992ZM16.8739 13.2031L16.5132 13.7352L16.8739 13.2031ZM16.6072 12.608L17.2474 12.6663L16.6072 12.608ZM9.96701 7.97112L9.7003 7.3862L9.96701 7.97112ZM7.09568 16.1512L6.60498 16.5665L7.09568 16.1512ZM7.76069 16.2846L7.48803 15.7024L7.76069 16.2846ZM17.8074 14.3395L17.2054 14.114L17.8074 14.3395ZM17.5865 13.6862L17.9472 13.154L17.5865 13.6862ZM10.4187 6.60138L9.77797 6.54953L10.4187 6.60138ZM17.5875 10.6979L17.2268 10.1658L17.5875 10.6979ZM17.8085 10.0449L17.2064 10.27L17.8085 10.0449ZM9.19543 8.40859L8.82999 7.8797L9.19543 8.40859ZM8.56013 8.47458L8.8328 7.89241L8.56013 8.47458ZM6.2546 13.6871L6.61532 14.2192L6.2546 13.6871ZM16.7456 16.1506L17.2363 16.5659L16.7456 16.1506ZM13.4237 6.60166L12.7829 6.65352L13.4237 6.60166ZM13.875 7.97278L13.6078 8.55747L13.875 7.97278ZM13.6078 8.55747C13.716 8.60692 13.8226 8.66137 13.9273 8.72085L14.5625 7.60304C14.4249 7.52484 14.2847 7.45318 14.1422 7.38808L13.6078 8.55747ZM12.7829 6.65352L12.8516 7.50147L14.1331 7.39776L14.0645 6.54981L12.7829 6.65352ZM10.9808 6.72169C11.6032 6.61648 12.2393 6.61658 12.8616 6.72198L13.0763 5.45431C12.312 5.32487 11.5308 5.32475 10.7665 5.45396L10.9808 6.72169ZM10.991 7.49959L11.0595 6.65323L9.77797 6.54953L9.70948 7.39588L10.991 7.49959ZM9.91115 8.72085C10.0168 8.6608 10.1244 8.60587 10.2337 8.55604L9.7003 7.3862C9.55644 7.4518 9.41481 7.52408 9.27588 7.60304L9.91115 8.72085ZM9.85557 8.75243L9.91115 8.72085L9.27588 7.60304L9.2203 7.63463L9.85557 8.75243ZM9.56086 8.93748C9.65577 8.8719 9.75406 8.81013 9.85557 8.75244L9.2203 7.63463C9.08595 7.71098 8.95577 7.79279 8.82999 7.8797L9.56086 8.93748ZM7.486 8.68137L8.28747 9.05675L8.8328 7.89241L8.03133 7.51703L7.486 8.68137ZM6.6347 10.2691C6.85568 9.67835 7.17709 9.1296 7.58438 8.64784L6.60253 7.81776C6.09984 8.41237 5.70322 9.08953 5.43048 9.81863L6.6347 10.2691ZM7.32511 10.6467L6.61432 10.1649L5.89288 11.2291L6.60367 11.711L7.32511 10.6467ZM7.8551 12.1903C7.8551 12.0699 7.86057 11.9503 7.87132 11.8319L6.59088 11.7156C6.57663 11.8726 6.56939 12.0309 6.56939 12.1903H7.8551ZM7.8716 12.5516C7.86066 12.4322 7.8551 12.3117 7.8551 12.1903H6.56939C6.56939 12.351 6.57675 12.5106 6.59124 12.6689L7.8716 12.5516ZM6.61532 14.2192L7.32548 13.7378L6.60404 12.6735L5.89388 13.1549L6.61532 14.2192ZM7.58637 15.7359C7.17874 15.2543 6.85699 14.7056 6.63568 14.1149L5.43169 14.566C5.70484 15.2951 6.10188 15.9721 6.60498 16.5665L7.58637 15.7359ZM8.29108 15.3263L7.48803 15.7024L8.03335 16.8668L8.83641 16.4907L8.29108 15.3263ZM9.85556 15.6281C9.75502 15.571 9.65765 15.5098 9.56358 15.445L8.8336 16.5033C8.95826 16.5893 9.08723 16.6703 9.2203 16.7459L9.85556 15.6281ZM9.91115 15.6597L9.85557 15.6281L9.2203 16.7459L9.27588 16.7775L9.91115 15.6597ZM10.2335 15.8244C10.1243 15.7746 10.0167 15.7197 9.91115 15.6597L9.27588 16.7775C9.4147 16.8564 9.55621 16.9286 9.69995 16.9942L10.2335 15.8244ZM11.0592 17.7281L10.9907 16.8808L9.70913 16.9845L9.7777 17.8318L11.0592 17.7281ZM12.8619 17.6594C12.2394 17.7648 11.6031 17.7649 10.9805 17.6597L10.7661 18.9274C11.5307 19.0567 12.3121 19.0566 13.0767 18.927L12.8619 17.6594ZM12.8519 16.8789L12.7832 17.7278L14.0647 17.8316L14.1334 16.9826L12.8519 16.8789ZM13.9273 15.6597C13.8227 15.7191 13.7162 15.7735 13.6081 15.823L14.1426 16.9923C14.2849 16.9273 14.425 16.8557 14.5625 16.7775L13.9273 15.6597ZM13.9828 15.6281L13.9273 15.6597L14.5625 16.7775L14.6181 16.7459L13.9828 15.6281ZM14.276 15.4441C14.1816 15.5093 14.0838 15.5707 13.9828 15.6281L14.6181 16.7459C14.7517 16.67 14.8813 16.5886 15.0064 16.5022L14.276 15.4441ZM16.3532 15.7019L15.5489 15.3252L15.0036 16.4895L15.8079 16.8662L16.3532 15.7019ZM17.2054 14.114C16.9841 14.7049 16.6624 15.2536 16.2548 15.7354L17.2363 16.5659C17.7394 15.9713 18.1364 15.2941 18.4095 14.5649L17.2054 14.114ZM16.5132 13.7352L17.2258 14.2183L17.9472 13.154L17.2346 12.671L16.5132 13.7352ZM15.9833 12.1903C15.9833 12.311 15.9778 12.4309 15.967 12.5497L17.2474 12.6663C17.2617 12.5089 17.269 12.3501 17.269 12.1903H15.9833ZM15.9673 11.8338C15.9779 11.9516 15.9833 12.0705 15.9833 12.1903H17.269C17.269 12.0318 17.2619 11.8743 17.2478 11.7181L15.9673 11.8338ZM17.2268 10.1658L16.5135 10.6493L17.235 11.7135L17.9482 11.23L17.2268 10.1658ZM16.2568 8.64839C16.6641 9.13026 16.9855 9.67913 17.2064 10.27L18.4107 9.81972C18.138 9.09049 17.7414 8.41318 17.2388 7.81845L16.2568 8.64839ZM15.5526 9.05787L16.3552 8.68193L15.8099 7.5176L15.0072 7.89353L15.5526 9.05787ZM13.9828 8.75244C14.0848 8.81037 14.1835 8.87242 14.2788 8.93831L15.01 7.88081C14.8837 7.79349 14.753 7.7113 14.6181 7.63463L13.9828 8.75244ZM13.9273 8.72085L13.9828 8.75244L14.6181 7.63463L14.5625 7.60304L13.9273 8.72085ZM15.0072 7.89353C15.0124 7.89112 15.0174 7.88972 15.0215 7.88908C15.0254 7.88848 15.0275 7.88872 15.0274 7.88871C15.0272 7.88869 15.0252 7.88843 15.0219 7.88714C15.0185 7.88586 15.0144 7.88382 15.01 7.88081L14.2788 8.93831C14.6299 9.18114 15.1135 9.26348 15.5526 9.05787L15.0072 7.89353ZM17.2478 11.7181C17.2473 11.7127 17.2475 11.708 17.2481 11.7043C17.2487 11.7006 17.2495 11.6986 17.2496 11.6984C17.2497 11.6982 17.2489 11.7002 17.2463 11.7033C17.2436 11.7066 17.2398 11.7103 17.235 11.7135L16.5135 10.6493C16.103 10.9276 15.928 11.3993 15.9673 11.8338L17.2478 11.7181ZM15.0064 16.5022C15.0108 16.4992 15.0149 16.4972 15.0182 16.4959C15.0216 16.4946 15.0236 16.4944 15.0237 16.4944C15.0238 16.4943 15.0218 16.4946 15.0179 16.494C15.0138 16.4933 15.0088 16.4919 15.0036 16.4895L15.5489 15.3252C15.1103 15.1198 14.6271 15.2018 14.276 15.4441L15.0064 16.5022ZM14.1334 16.9826C14.133 16.9883 14.1317 16.9935 14.1301 16.9974C14.1287 17.0012 14.1274 17.0029 14.1274 17.0029C14.1275 17.0028 14.1286 17.0013 14.1314 16.9991C14.1341 16.9969 14.1379 16.9945 14.1426 16.9923L13.6081 15.823C13.2124 16.0038 12.8917 16.3877 12.8519 16.8789L14.1334 16.9826ZM13.0767 18.927C13.6446 18.8308 14.0225 18.353 14.0647 17.8316L12.7832 17.7278C12.7839 17.7189 12.7877 17.7065 12.7992 17.6934C12.8117 17.679 12.8338 17.6641 12.8619 17.6594L13.0767 18.927ZM9.7777 17.8318C9.81991 18.3534 10.198 18.8313 10.7661 18.9274L10.9805 17.6597C11.0086 17.6644 11.0307 17.6793 11.0433 17.6936C11.0547 17.7067 11.0585 17.7192 11.0592 17.7281L9.7777 17.8318ZM9.69995 16.9942C9.70464 16.9963 9.70841 16.9988 9.71116 17.001C9.71393 17.0032 9.71509 17.0047 9.71516 17.0048C9.71517 17.0048 9.7139 17.0031 9.71243 16.9993C9.7109 16.9954 9.70959 16.9902 9.70913 16.9845L10.9907 16.8808C10.9509 16.3891 10.6296 16.0051 10.2335 15.8244L9.69995 16.9942ZM8.83641 16.4907C8.83126 16.4931 8.82623 16.4945 8.82214 16.4951C8.81823 16.4957 8.81619 16.4955 8.81628 16.4955C8.81645 16.4955 8.8184 16.4958 8.82178 16.497C8.82515 16.4983 8.82925 16.5003 8.8336 16.5033L9.56358 15.445C9.21254 15.2028 8.72954 15.121 8.29108 15.3263L8.83641 16.4907ZM6.59124 12.6689C6.59173 12.6743 6.59148 12.679 6.59089 12.6828C6.5903 12.6865 6.5895 12.6885 6.58941 12.6887C6.58934 12.6888 6.59016 12.6869 6.59272 12.6838C6.59541 12.6805 6.59926 12.6768 6.60404 12.6735L7.32548 13.7378C7.73654 13.4591 7.91143 12.9866 7.8716 12.5516L6.59124 12.6689ZM6.60367 11.711C6.59889 11.7077 6.59504 11.704 6.59235 11.7007C6.58979 11.6976 6.58897 11.6957 6.58904 11.6958C6.58913 11.6961 6.58993 11.698 6.59052 11.7017C6.59111 11.7055 6.59137 11.7102 6.59088 11.7156L7.87132 11.8319C7.9108 11.3972 7.73585 10.9252 7.32511 10.6467L6.60367 11.711ZM5.43048 9.81863C5.22679 10.3632 5.45696 10.9336 5.89288 11.2291L6.61432 10.1649C6.62174 10.1699 6.63084 10.1795 6.63663 10.1962C6.643 10.2146 6.6449 10.2418 6.6347 10.2691L5.43048 9.81863ZM17.2388 7.81845C16.8715 7.38384 16.2773 7.2987 15.8099 7.5176L16.3552 8.68193C16.3473 8.68564 16.3347 8.68857 16.3177 8.68529C16.2991 8.68168 16.2752 8.67014 16.2568 8.64839L17.2388 7.81845ZM8.03133 7.51703C7.56401 7.29816 6.96987 7.38326 6.60253 7.81776L7.58438 8.64784C7.566 8.66958 7.54208 8.68112 7.52346 8.68472C7.50647 8.68801 7.49392 8.68508 7.486 8.68137L8.03133 7.51703ZM17.2346 12.671C17.2394 12.6742 17.2432 12.6779 17.2459 12.6812C17.2485 12.6844 17.2493 12.6863 17.2492 12.6861C17.2491 12.6859 17.2483 12.684 17.2478 12.6802C17.2472 12.6765 17.2469 12.6718 17.2474 12.6663L15.967 12.5497C15.9274 12.9845 16.1023 13.4567 16.5132 13.7352L17.2346 12.671ZM9.70948 7.39588C9.70994 7.39018 9.71125 7.38503 9.71279 7.38108C9.71425 7.3773 9.71553 7.37558 9.71551 7.37561C9.71545 7.37569 9.71428 7.37721 9.71151 7.37942C9.70876 7.38163 9.70499 7.38406 9.7003 7.3862L10.2337 8.55604C10.6299 8.3754 10.9512 7.99131 10.991 7.49959L9.70948 7.39588ZM6.60498 16.5665C6.97239 17.0006 7.56624 17.0856 8.03335 16.8668L7.48803 15.7024C7.49594 15.6987 7.50848 15.6958 7.52547 15.6991C7.54408 15.7027 7.56799 15.7142 7.58637 15.7359L6.60498 16.5665ZM18.4095 14.5649C18.6134 14.0203 18.3832 13.4496 17.9472 13.154L17.2258 14.2183C17.2183 14.2132 17.2092 14.2037 17.2034 14.187C17.1971 14.1686 17.1952 14.1413 17.2054 14.114L18.4095 14.5649ZM10.7665 5.45396C10.1984 5.55 9.82018 6.02789 9.77797 6.54953L11.0595 6.65323C11.0588 6.66214 11.055 6.67462 11.0435 6.68772C11.031 6.70209 11.0088 6.71695 10.9808 6.72169L10.7665 5.45396ZM17.9482 11.23C18.3841 10.9346 18.6142 10.3642 18.4107 9.81972L17.2064 10.27C17.1962 10.2427 17.1981 10.2155 17.2044 10.1971C17.2102 10.1804 17.2193 10.1708 17.2268 10.1658L17.9482 11.23ZM8.82999 7.8797C8.82564 7.8827 8.82154 7.88475 8.81816 7.88603C8.81478 7.88731 8.81282 7.88757 8.81266 7.88759C8.81256 7.8876 8.81461 7.88736 8.81852 7.88797C8.82261 7.8886 8.82765 7.89 8.8328 7.89241L8.28747 9.05675C8.72631 9.26229 9.20973 9.18008 9.56086 8.93748L8.82999 7.8797ZM5.89388 13.1549C5.45779 13.4506 5.22763 14.0214 5.43169 14.566L6.63568 14.1149C6.6459 14.1422 6.64401 14.1695 6.63764 14.1879C6.63185 14.2046 6.62274 14.2141 6.61532 14.2192L5.89388 13.1549ZM15.8079 16.8662C16.275 17.085 16.8689 17.0001 17.2363 16.5659L16.2548 15.7354C16.2732 15.7136 16.2971 15.7021 16.3157 15.6985C16.3327 15.6952 16.3453 15.6982 16.3532 15.7019L15.8079 16.8662ZM14.0645 6.54981C14.0223 6.0283 13.6443 5.55049 13.0763 5.45431L12.8616 6.72198C12.8336 6.71722 12.8114 6.70236 12.7989 6.688C12.7875 6.6749 12.7837 6.66242 12.7829 6.65352L14.0645 6.54981ZM14.1422 7.38808C14.1376 7.38594 14.1338 7.38351 14.131 7.38131C14.1283 7.3791 14.1271 7.37758 14.1271 7.3775C14.127 7.37748 14.1283 7.37919 14.1298 7.38297C14.1313 7.38692 14.1326 7.39206 14.1331 7.39776L12.8516 7.50147C12.8913 7.99276 13.2121 8.37664 13.6078 8.55747L14.1422 7.38808Z"
      fill="#185C65"
    />
    <path
      d="M11.0755 10.7354L10.7664 10.1915L11.0755 10.7354C11.5996 10.4375 12.2418 10.4375 12.7659 10.7354L12.7937 10.7512L13.0173 10.3577L12.7937 10.7512C13.3115 11.0454 13.6313 11.5951 13.6313 12.1907C13.6313 12.7862 13.3115 13.3359 12.7937 13.6301C12.7937 13.6301 12.7937 13.6301 12.7937 13.6301L12.7659 13.6459L12.7659 13.6459C12.2418 13.9438 11.5996 13.9438 11.0755 13.6459L11.0755 13.6459L11.0477 13.6301C11.0477 13.6301 11.0477 13.6301 11.0477 13.6301C10.5299 13.3359 10.2101 12.7862 10.2101 12.1907C10.2101 11.5951 10.5299 11.0454 11.0477 10.7512L11.0755 10.7354Z"
      stroke="#185C65"
      strokeWidth="1.28571"
    />
  </svg>
);

export const UserMenuIcon = () => (
  <svg width="64" height="36" viewBox="0 0 64 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="36" rx="18" fill="#FDFDFB" />
    <circle cx="19" cy="12.0547" r="4" stroke="#2B303A" strokeWidth="2" />
    <path
      d="M27 27.0547V23.6102C27 21.6466 25.4081 20.0547 23.4444 20.0547H14.5556C12.5919 20.0547 11 21.6466 11 23.6102V27.0547"
      stroke="#2B303A"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M39.6667 16.2214L44.6858 21.2404C44.8594 21.414 45.1408 21.414 45.3144 21.2404L50.3334 16.2214"
      stroke="#2B303A"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const UserMenuSelectedIcon = () => (
  <svg width="64" height="36" viewBox="0 0 64 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="36" rx="18" fill="#FDFDFB" />
    <circle cx="19" cy="12.0557" r="4" stroke="#2B303A" strokeWidth="2" />
    <path
      d="M27 27.0557V23.6112C27 21.6475 25.4081 20.0557 23.4444 20.0557H14.5556C12.5919 20.0557 11 21.6475 11 23.6112V27.0557"
      stroke="#2B303A"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M50.333 20.6668L45.3139 15.6478C45.1404 15.4742 44.859 15.4742 44.6854 15.6478L39.6663 20.6668"
      stroke="#01D1B8"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const HelpCenterMenuIcon = () => {
  return (
    <SvgIcon sx={{ height: '24px', width: '24px' }}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
          stroke="#185C65"
          strokeWidth="1.16316"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9997 14.8C13.5461 14.8 14.7997 13.5463 14.7997 12C14.7997 10.4536 13.5461 9.19995 11.9997 9.19995C10.4533 9.19995 9.19971 10.4536 9.19971 12C9.19971 13.5463 10.4533 14.8 11.9997 14.8Z"
          stroke="#185C65"
          strokeWidth="1.16316"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9807 13.981L16.9487 16.949"
          stroke="#185C65"
          strokeWidth="1.16316"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.05054 16.949L10.0185 13.981"
          stroke="#185C65"
          strokeWidth="1.16316"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9807 10.0189L16.9487 7.0509"
          stroke="#185C65"
          strokeWidth="1.16316"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.981 10.0191L16.452 7.5481"
          stroke="#185C65"
          strokeWidth="1.16316"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.05054 7.0509L10.0185 10.0189"
          stroke="#185C65"
          strokeWidth="1.16316"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export const SecureMenuIcon = (props) => {
  return (
    <SvgIcon {...props} sx={{ height: '32px', width: '32px' }}>
      <svg fill="none">
        <path
          d="M12.8211 6.05645C11.5932 5.88681 10.3428 6.10167 9.2419 6.6715C8.14101 7.24134 7.24364 8.13817 6.67315 9.23872C6.10266 10.3393 5.88705 11.5895 6.05596 12.8176C6.22488 14.0456 6.77002 15.1912 7.61646 16.0969"
          stroke="#185C65"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M9.14318 17.2762C9.91523 17.6943 10.7696 17.9378 11.646 17.9896C12.5225 18.0413 13.3996 17.9002 14.2155 17.576C15.0314 17.2518 15.7662 16.7525 16.3681 16.1133C16.97 15.4742 17.4243 14.7107 17.6989 13.8768"
          stroke="#185C65"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M14.6747 6.62914C15.6726 7.12612 16.5124 7.89132 17.0998 8.8389C17.6871 9.78649 17.9989 10.879 18 11.9938"
          stroke="#185C65"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
      </svg>
    </SvgIcon>
  );
};
